/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var DEFAULT_MENU_WIDTH = [232, 64];

export { DEFAULT_MENU_WIDTH };
//# sourceMappingURL=constant.js.map
